export const SELF_SENDER_LABEL = "You";
export const SENDER_PREFIX_SEPARATOR = ": ";

// Branch 4 exists so a system announcement renders with no attribution.
// It must never render the literal string system.
export function buildPreviewLine(payload: {
  preview: string | null | undefined;
  senderDisplayName: string | null | undefined;
  senderIsSelf: boolean;
  emptyLabel: string;
}): string {
  const preview = payload.preview;
  if (preview == null || preview.trim() === "") {
    return payload.emptyLabel;
  }
  if (payload.senderIsSelf) {
    return `${SELF_SENDER_LABEL}${SENDER_PREFIX_SEPARATOR}${preview}`;
  }
  const name = payload.senderDisplayName?.trim() ?? "";
  if (name.length > 0) {
    return `${name}${SENDER_PREFIX_SEPARATOR}${preview}`;
  }
  return preview;
}
